import React from "react";
import { Link } from "react-router-dom";
import { LABELS } from "@/utils/constants/appConstants/commonConstants";

interface BrandCardProps {
    brand: any;
}

const BrandCard: React.FC<BrandCardProps> = (props) => {
    return (
        <div className="gs-brand-card">
            <div className="gs-brand-card__inner">
                <div className="gs-brand-card__avatar" aria-hidden>
                    <em className="icon ni ni-file-doc" id="brand-list-icon" />
                </div>
                <p className="gs-brand-card__name" id="brand-title">
                    {props.brand.name}
                </p>
                <p className="gs-brand-card__id" id="brand-id">
                    {props.brand.id}
                </p>
                <p className="gs-brand-card__company" id="brand-company-name">
                    {props.brand.company_name} Company
                </p>
                <Link to={`/brand/${props.brand.id}`} className="gs-brand-card__link" id="brand-view-detail">
                    {LABELS.VIEW_DETAILS}
                </Link>
            </div>
        </div>
    );
};

export default BrandCard;
